import { useEffect } from 'react';

const MAX_FRAMES = 60;

export const useFocusPageHeading = (stepKey: string | undefined) => {
  useEffect(() => {
    if (!stepKey) return;

    let frame = 0;
    let handle = 0;

    const focusHeading = () => {
      const heading = document.querySelector<HTMLElement>('main h1');
      if (!heading) {
        frame += 1;
        if (frame < MAX_FRAMES) handle = requestAnimationFrame(focusHeading);
        return;
      }
      if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
      heading.focus();
    };

    handle = requestAnimationFrame(focusHeading);
    return () => cancelAnimationFrame(handle);
  }, [stepKey]);
};
